import jfwSchedule from "./com.jacksonfamilywines.Schedule";

export default {
  "com.jacksonfamilywines.Schedule": jfwSchedule,
};
